import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

/* Components */
import SVG from '../../../../components/icons/single_ticket';
import NoTicketsAvailable from '../../../../components/react-no-tickets-available';

const NoTicketsForFilter = ({onResetFiltersClick}) => {
  /* @TODO place holder for svg image since it is not available */
  const svgImage = <SVG width="72px" height="96px" />;
  const headerText = (
    <FormattedMessage id="NoTicketsForFilter.event.header" defaultMessage="Sorry, no tickets match your filters." />
  );
  const buttonPillText = (
    <FormattedMessage id="NoTicketsForFilter.event.resetfilters" defaultMessage="See all tickets" />
  );

  return (
    <NoTicketsAvailable
      svgImage={svgImage}
      headerText={headerText}
      buttonText={buttonPillText}
      onClick={onResetFiltersClick}
    >
      <FormattedMessage
        id="NoTicketsForFilter.event.filtercontent"
        defaultMessage="But there are still tickets left! Please update your filter criteria and try again."
      />
    </NoTicketsAvailable>
  );
};

NoTicketsForFilter.propTypes = {
  onResetFiltersClick: PropTypes.func.isRequired,
};

export default NoTicketsForFilter;
